import React, { useEffect, useState } from 'react'; 
import ListTemplate from '../../../Reusable_Components/ListTemplate';  
import axios from 'axios'; 
import { API_ROUTES, API_DOMAIN, headers } from '../../../Reusable_Components/apiConfig';  

const InvoiceItemList = ({ invoice }) => { 
  const [invoiceItems, setInvoiceItems] = useState([]); 
  
  useEffect(() => { 

  
    fetchInvoiceItems(); 
  }, [invoice]); 

  const fetchInvoiceItems = async () => { 
      
    try { 
      const url = `${API_DOMAIN}${API_ROUTES.invoice_item}?invoice=${invoice}`
      const token = localStorage.getItem('token'); 
       
      const response = await axios.get(url, { headers }); 
      setInvoiceItems(response.data); 
    } catch (error) { 
      console.error('Error fetching invoice items:', error); 
    } 
  }; 


  
  
  const columns = [ 
 
    { label: 'Description', value: 'description' }, 
    { label: 'Quantity', value: 'quantity' }, 
    { label: 'Unit Price', value: 'unit_price' }, 
    { label: 'Total Price', value: 'total_price' }, 
  ]; 
  
  const handleViewDetails = (invoiceItemId) => { 
    //console.log('View Details', invoiceItemId); 
    const encodedId = btoa(invoiceItemId);
    window.location.href = `/invoice-item/details/${encodedId}`; 
  }; 

  const handleRemoveInvoiceItem = async (invoiceItemId) => {
  try {
    const url = `${API_DOMAIN}${API_ROUTES.invoice_item}${invoiceItemId}/`;
    const token = localStorage.getItem('token');
    
    await axios.delete(url, { headers });
    setInvoiceItems(invoiceItems.filter(item => item.id !== invoiceItemId));
  } catch (error) {
    console.error('Error removing invoice item:', error);
  }
};
  
  const actionButtons = [ 
    { label: 'View Details', handler: handleViewDetails }, 
    // { label: 'Remove', handler: handleRemoveInvoiceItem }
  ]; 
  
  return <ListTemplate columns={columns} data={invoiceItems} actionButtons={actionButtons} />; 
}; 
  
export default InvoiceItemList;